import { useMemo } from 'react';
import { useGrowthBookValues } from '../contexts/GrowthBookContext';

export const useGBValue = () => {
  const {
    content,
    paywallTheme,
    animatedPictures,
    steps,
    attributeSelectionStyle,
    postSignupRedirect,
    magicLink,
    paywallNavType,
    paywallFlow,
    paywallOrder,
    premiumTokensAmount,
    premiumInstantTokens,
    variation,
    isNDG,
  } = useGrowthBookValues();

  const ab_testing = useMemo(() => {
    const baseTesting = {
      'lander-content': content?.name || 'none',
      // NSFW (default) / SFW (?variation=sfw). The content config's `name` is
      // shared by both branches, so this is the only thing that separates the two
      // arms server-side and in Mixpanel. Rides as a plain string like the rest.
      'createsexfriend-variation': variation || 'nsfw',
      'createsexfriends-paywall-theme': paywallTheme,
      'createsexfriend-animated-pictures': animatedPictures,
      'createsexfriends-post-signup-redirect': postSignupRedirect,
      'createsexfriends-magicLink': magicLink,
      'createsexfriend-paywall-nav-config': paywallNavType || 'paywall',
      // Forwarded to the backend so it lands in the registration Redis payload;
      // /lobby reads it to route to chat vs generation after payment.
      'createsexfriend-paywall-flow': paywallFlow || 'generation',
      // Popup-first A/B arm ordering. Rides in ab_testing so it's seeded as a
      // user experiment for segmentation; the backend does NOT branch on it (the
      // nav `type` stays 'paywall_popup'). Consumed on the LP by createAccount.
      'createsexfriend-paywall-order': paywallOrder || 'after_signup',
      // premium-tokens-amount / premium-instant-tokens-amount drive the paywall
      // popup's token-bonus pill (platform-global flag names). Forward them (as
      // strings, per the ab_testing contract) ONLY in the popup flow so backend +
      // Mixpanel can attribute conversions to the token-bonus variant the user saw.
      ...(paywallNavType === 'paywall_popup'
        ? {
            'premium-tokens-amount': String(premiumTokensAmount ?? ''),
            'premium-instant-tokens-amount': String(
              premiumInstantTokens ?? '0|0|0',
            ),
          }
        : {}),
    };

    if (isNDG) {
      return {
        ...baseTesting,
        'createsexfriend-steps': steps,
        'createsexfriend-attribute-selection-style': attributeSelectionStyle,
      };
    }

    return baseTesting;
  }, [
    content,
    paywallTheme,
    animatedPictures,
    steps,
    attributeSelectionStyle,
    postSignupRedirect,
    magicLink,
    paywallNavType,
    paywallFlow,
    paywallOrder,
    premiumTokensAmount,
    premiumInstantTokens,
    variation,
    isNDG,
  ]);

  return ab_testing;
};
